// extracted by mini-css-extract-plugin
export var modalFooter = "_mk-0";